import React from "react";
import Register from "../components/RegisterAdvocate/Register";

const RegisterPage = () => {
  return (
    <>
      <Register />
    </>
  );
};

export default RegisterPage;
